import axios from "axios";
/**
 * Authentification Web Service 
 * @returns 
 */
export async function formulaire (data){
    try{
        const response = await axios.post(`https://api.competition.cleges.com/api/v1/competitions`,data,{
            IsEssential: true
          });
          return response;
    }catch(error){
        return error?.response
    }
}   
/**
 * Authentification Web Service 
 * @returns 
 */
export async function formulaireTable (data){
    try{
        const response = await axios.post(`https://api.competition.cleges.com/api/v1/competitions/table`,data,{
            IsEssential: true
          });
          return response;
    }catch(error){
        return error?.response
    }
}   
